import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
declare let window: any;
declare let $: any;
declare let cordova: any;

const successCallback = (result) => {
  console.log(result); // true - enabled, false - disabled
};

const errorCallback = (error) => {
  console.log(error);
};

if (environment.production) {
  enableProdMode();
}
/*
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
*/

const bootstrap = () => {
  if(environment.production){
    window.console.log = function(){}
  }
  
  $(document).ready(() => {
    var root = document.documentElement;
    console.log("SCREEN RESOLUTION", window.screen, window.screenY);
    root.style.setProperty('--screen-width', window.innerWidth + "px");
    root.style.setProperty('--screen-height', window.innerHeight + "px");
    window.addEventListener('resize', () => {
      console.log("Resized", window.screen.availWidth, window.screen.availHeight)
      root.style.setProperty('--screen-width', window.innerWidth + "px");
      root.style.setProperty('--screen-height', window.innerHeight + "px");
    });
  });

  if (window.plugins && window.plugins.preventscreenshot) {
    window.plugins.preventscreenshot.enable(successCallback, errorCallback);
  }

  if(window['cordova'] && window['cordova']['InAppBrowser']){
    window.open = cordova.InAppBrowser.open;
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
};

if (typeof window["cordova"] !== "undefined") {
  document.addEventListener('backbutton', (event) => { event.preventDefault(); }, false);
  document.addEventListener("deviceready", () => { bootstrap(); }, false);
} else {
  bootstrap();
}
